import { ApplicationRoutePaths } from "@shared-core/routes/application-route-paths";

export abstract class OcrQuotaitonExpirationSettingsRoutePaths extends ApplicationRoutePaths {
  static override readonly ROOT = "ocr-quotaiton-expiration-settings";
}
